import { addDays } from "date-fns/addDays";
import { memo } from "react";
import { Link } from "react-router-dom";
import { cn } from "@tellescope/ui";
import { useDateFnsFormattersWithLocale } from "@tellescope/ui";

export interface WeekViewHeadersProps {
  startDate: Date;
  timezone: string;
  getOnDayClick?: (date: Date) => (() => void) | string;
}

const WeekViewHeadersInner = ({ startDate, timezone, getOnDayClick }: WeekViewHeadersProps) => {
  const { formatInTimeZone } = useDateFnsFormattersWithLocale();

  return (
    <>
      {Array.from({ length: 7 }, (_, i) => addDays(startDate, i)).map((date, i) => {
        const dateString = formatInTimeZone(addDays(startDate, i), timezone, "d");
        const onClick = getOnDayClick?.(addDays(startDate, i));

        const Component = onClick ? (typeof onClick === "string" ? Link : "button") : "div";

        return (
          <Component
            key={`day-of-week-header-${dateString}`}
            className={cn(
              "flex items-center justify-center py-2 text-xs font-normal text-muted-foreground border-b border-b-gray-200 gap-2",
              !!onClick && "transition-colors hover:text-primary"
            )}
            to={typeof onClick === "string" && typeof Component !== "string" ? onClick : ""}
            onClick={typeof onClick === "function" && Component === "button" ? onClick : undefined}
          >
            {formatInTimeZone(date, timezone, "EEE")}
            <span className="text-primary font-medium">{dateString}</span>
          </Component>
        );
      })}
    </>
  );
};

export const WeekViewHeaders = memo(WeekViewHeadersInner);
